module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8004.0a87ace7.png";